<template>
  <div class="pagination-wrap">
    <div>
      <!-- 이전 페이지로 -->
      <button type="button" :class="!isDark ? 'icon-left-round-arrow' : 'icon-dark-left-arrow'" @click="goBeforePage" v-if="pageModel.pageNo > 1">
        <span class="blind">이전목록</span>
      </button>
      <!-- 특정 페이지로 -->
<!--      <button type="button" v-for="no in maxPage" v-if="no >= 1 && no <= maxPage">-->
      <button type="button" v-for="no in maxPage" v-if="no >= firstNum && no <= lastNum">
        <span class="paging" :class="{'active': pageModel.pageNo === no}" v-on:click="goPageNo(no)">{{ no }}</span>
      </button>
      <!-- 다음 페이지로 -->
      <button type="button" :class="!isDark ? 'icon-right-round-arrow' : 'icon-dark-right-arrow'" @click="goNextPage" v-if="pageModel.pageNo < maxPage">
        <span class="blind">다음목록</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
      isDark: Boolean,
      totalRows: Number,
      pageModel : {			// 페이지 정보 모델(orderCriteria: 정렬기준, page:현재페이지번호, size:한페이지에 나타낼 데이터 수)
          type: Object,
          required: true,
      },
    },
    methods: {
        goBeforePage() {
            let beforePageNo = parseInt(this.pageModel.pageNo) - 1;
            this.$emit('movePage', beforePageNo);
        },
        goNextPage() {
            let nextPageNo = parseInt(this.pageModel.pageNo) + 1;
            this.$emit('movePage', nextPageNo);
        },
        goPageNo(pageNo) {
            this.$emit('movePage', pageNo);
        }
    },
    computed: {
      maxPage() {
          return Math.ceil(this.totalRows / this.pageModel.size);
      },
      firstNum() {			// 화면에 보여질 첫번째 페이지 번호
        let startNum = this.lastNum - (this.pageModel.size - 1)

        if(this.lastNum % this.pageModel.size != 0) {
          startNum = this.lastNum - (this.lastNum % this.pageModel.size) + 1;
        }

        return startNum;
      },
      lastNum() {				// 화면에 보여질 마지막 페이지 번호
        let endNum = this.pageGroup * this.pageModel.size;
        if(endNum > this.totalPage) {
          endNum = this.totalPage;
        }

        if(endNum === 0) {
          endNum = 1;
        }
        return endNum;
      },
      pageGroup() {
        return Math.ceil(this.pageModel.pageNo / this.pageModel.size);
      },
      totalPage() {
        return Math.ceil(this.totalRows / this.pageModel.size);
      }
    }
};
</script>

<style lang="scss" scoped>
    @import "@/assets/styles/common/pagination.scss";
</style>